import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M18.2339 5.78703L16.7951 9.74368C16.6536 10.133 16.8544 10.5633 17.2437 10.7048C17.633 10.8464 18.0633 10.6456 18.2048 10.2563L20.13 4.96208C20.3789 4.27759 19.7079 3.61754 19.0276 3.87765L2.42141 10.2271C1.76333 10.4787 1.67948 11.3757 2.27949 11.7449L8.4248 15.5267L9.82917 18.3354C10.0144 18.7059 10.4649 18.8561 10.8354 18.6708C11.2059 18.4856 11.3561 18.0351 11.1708 17.6646L9.91256 15.1481L11.0303 14.0303C11.3232 13.7374 11.3232 13.2626 11.0303 12.9697C10.7374 12.6768 10.2626 12.6768 9.96966 12.9697L8.88854 14.0508L4.18739 11.1578L18.2339 5.78703ZM14 11.75C14.4142 11.75 14.75 12.0858 14.75 12.5V12.89C15.4362 12.4838 16.2348 12.25 17.0882 12.25C19.6785 12.25 21.75 14.3925 21.75 17C21.75 19.6075 19.6785 21.75 17.0882 21.75C15.7956 21.75 14.6274 21.2132 13.786 20.3528C13.4964 20.0567 13.5017 19.5819 13.7978 19.2923C14.094 19.0026 14.5688 19.0079 14.8584 19.3041C15.4328 19.8914 16.2205 20.25 17.0882 20.25C18.8187 20.25 20.25 18.8108 20.25 17C20.25 15.1892 18.8187 13.75 17.0882 13.75C16.0808 13.75 15.1791 14.2341 14.5967 14.9989C14.4017 15.255 14.0651 15.3581 13.7602 15.2552C13.4553 15.1523 13.25 14.8664 13.25 14.5446V12.5C13.25 12.0858 13.5858 11.75 14 11.75ZM17.75 15.5C17.75 15.0858 17.4142 14.75 17 14.75C16.5858 14.75 16.25 15.0858 16.25 15.5V17C16.25 17.4142 16.5858 17.75 17 17.75H18.5C18.9142 17.75 19.25 17.4142 19.25 17C19.25 16.5858 18.9142 16.25 18.5 16.25H17.75V15.5Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
